/**
 * Recently Searched Products — Algolia Autocomplete Integration
 *
 * Tracks product clicks from Algolia autocomplete and displays them
 * as a "recently searched" source inside the autocomplete panel.
 */

(function () {
  const STORAGE_KEY = 'theme:recently-searched-products';
  const MAX_ITEMS = 3;
  const SOURCE_ID = 'recently-searched';
  const SOURCE_TITLE = 'Cautate recent';

  // --- LocalStorage helpers ---

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveItem(product) {
    try {
      let items = getItems().filter((p) => p.handle !== product.handle);
      items.unshift(product);
      if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {}
  }

  function removeItem(handle) {
    try {
      const items = getItems().filter((p) => p.handle !== handle);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {}
  }

  // --- Track clicks on Algolia product results ---

  document.addEventListener(
    'click',
    function (e) {
      const itemLink = e.target.closest(
        '.aa-Source[data-autocomplete-source-id="products"] .aa-ItemLink'
      );
      if (!itemLink) return;

      const item = itemLink.closest('.aa-Item');
      if (!item) return;

      const title =
        item.querySelector('.aa-ItemContentTitle')?.textContent?.trim() || '';
      const image = item.querySelector('.aa-ItemPicture img')?.src || '';
      const url = itemLink.getAttribute('href') || '';
      const handle = url.split('/products/')[1]?.split(/[?/]/)[0] || '';

      if (handle) {
        saveItem({ handle, title, image, url, timestamp: Date.now() });
      }
    },
    true
  );

  // --- Handle remove button clicks ---

  document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('[data-recently-searched-remove]');
    if (!removeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = removeBtn.dataset.recentlySearchedRemove;
    removeItem(handle);

    const item = removeBtn.closest('.aa-Item');
    if (item) item.remove();

    // If no items left, remove the entire section
    const source = document.querySelector(
      '[data-autocomplete-source-id="' + SOURCE_ID + '"]'
    );
    if (source && !source.querySelector('.aa-Item')) {
      source.remove();
    }
  });

  // --- Inject recently searched section into Algolia panel ---

  function escapeHTML(str) {
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function buildRecentlySearchedHTML(items) {
    const listItems = items
      .map(
        (p) => `
      <li class="aa-Item" role="option">
        <div class="aa-ItemLink aa-ProductItem">
          <a href="${escapeHTML(p.url)}">
            <div class="aa-ItemContent">
              <div class="aa-ItemPicture aa-ItemPicture--loaded">
                <img src="${escapeHTML(p.image)}" alt="${escapeHTML(p.title)}">
              </div>
              <div class="aa-ItemContentBody">
                <div class="aa-ItemContentTitleWrapper">
                  <div class="aa-ItemContentTitle">${escapeHTML(p.title)}</div>
                </div>
              </div>
            </div>
          </a>
          <button type="button" class="aa-recently-searched-remove p-1" data-recently-searched-remove="${escapeHTML(p.handle)}" aria-label="Sterge">
            <svg width="10" height="10" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M1 1l12 12M13 1L1 13"/></svg>
          </button>
        </div>
      </li>`
      )
      .join('');

    return `
      <section class="aa-Source" data-autocomplete-source-id="${SOURCE_ID}">
        <div class="aa-SourceHeader">
          <div class="aa-SourceHeader">
            <span class="aa-SourceHeaderTitle">${SOURCE_TITLE}</span>
            <div class="aa-SourceHeaderLine"></div>
          </div>
        </div>
        <ul class="aa-List grid">${listItems}</ul>
      </section>`;
  }

  function injectRecentlySearched(panelSection) {
    if (
      !panelSection ||
      panelSection.querySelector(
        '[data-autocomplete-source-id="' + SOURCE_ID + '"]'
      )
    )
      return;

    const items = getItems();
    if (!items.length) return;

    const productsSource = panelSection.querySelector(
      '.aa-Source[data-autocomplete-source-id="products"]'
    );

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = buildRecentlySearchedHTML(items);
    const recentSection = tempDiv.firstElementChild;

    if (productsSource) {
      productsSource.before(recentSection);
    } else {
      panelSection.prepend(recentSection);
    }
  }

  // --- Observe panel open/re-render ---

  const observer = new MutationObserver(function () {
    const panelSection = document.querySelector('.aa-Panel .aa-PanelSection--right, .aa-Panel .aa-PanelSection');
    if (panelSection) {
      injectRecentlySearched(panelSection);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
